// Helpers
import { getOutlinedPositionIcon } from "@/Common/helpers/Positions/icons";

// Layouts
import PageLayer from "@/Layouts/views/PageLayer";

// Layer
import Layer from "@/PayPlans/views/Layers/Departments/Managers/Sales";

export default function Managers() {
	const Icon = getOutlinedPositionIcon({ position: "Sales Managers" });
	return (
		<PageLayer title={"Sales Managers Pay Plans"} icon={Icon}>
			<Layer />
		</PageLayer>
	);
}
